import { Routes } from '@angular/router';

import { AuthGuard } from './guards/auth.guard';
import { StaticLayoutComponent } from './layout/static/static-layout.component';
import { DefaultLayoutComponent } from './layout/default/default-layout.component';

export const routes: Routes = [
  {
    path: '',
    component: StaticLayoutComponent,
    children: [
      { path: '', loadComponent: () => import('./views/pages/login/login.component').then(m => m.LoginComponent) },
      { path: 'about', loadComponent: () => import('./views/pages/about/about.component').then(m => m.AboutComponent) },
      { path: 'contact', loadComponent: () => import('./views/pages/contact/contact.component').then(m => m.ContactComponent) },
      { path: 'terms-of-service', loadComponent: () => import('./views/pages/terms-of-service/terms-of-service.component').then(m => m.TermsOfServiceComponent) }
    ]
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'dashboard',
        data: { title: 'Dashboard' },
        children: [
          {
            path: '', // Matches /dashboard
            loadChildren: () => import('./views/dashboard/routes').then((m) => m.routes),
          },
          {
            path: 'customers',
            loadChildren: () => import('./views/customers/routes').then((m) => m.routes),
            data: { title: 'Customers' }
          },
          {
            path: 'clinics',
            loadChildren: () => import('./views/clinics/routes').then((m) => m.routes)
          },
          {
            path: 'patients',
            loadChildren: () => import('./views/patients/routes').then((m) => m.routes),
          },
          {
            path: 'tests',
            loadChildren: () => import('./views/tests/routes').then((m) => m.routes)
          },
          {
            path: 'users',
            loadChildren: () => import('./views/users/routes').then((m) => m.routes)
          },
          {
            path: 'parameters',
            loadChildren: () => import('./views/parameters/routes').then((m) => m.routes)
          },
          {
            path: 'cities',
            loadChildren: () => import('./views/locations/city/routes').then((m) => m.routes)
          },
          {
            path: 'states',
            loadChildren: () => import('./views/locations/state/routes').then((m) => m.routes)
          },
          {
            path: 'countries',
            loadChildren: () => import('./views/locations/country/routes').then((m) => m.routes)
          },
          {
            path: 'theme',
            loadChildren: () => import('./views/theme/routes').then((m) => m.routes)
          },
          {
            path: 'base',
            loadChildren: () => import('./views/base/routes').then((m) => m.routes)
          },
          {
            path: 'buttons',
            loadChildren: () => import('./views/buttons/routes').then((m) => m.routes)
          },
          {
            path: 'forms',
            loadChildren: () => import('./views/forms/routes').then((m) => m.routes)
          },
          {
            path: 'icons',
            loadChildren: () => import('./views/icons/routes').then((m) => m.routes)
          },
          {
            path: 'notifications',
            loadChildren: () => import('./views/notifications/routes').then((m) => m.routes)
          },
          {
            path: 'widgets',
            loadChildren: () => import('./views/widgets/routes').then((m) => m.routes)
          },
          {
            path: 'charts',
            loadChildren: () => import('./views/charts/routes').then((m) => m.routes)
          },
          {
            path: 'pages',
            loadChildren: () => import('./views/pages/routes').then((m) => m.routes)
          }
        ]
      }
    ]
  },
  {
    path: '404',
    loadComponent: () => import('./views/pages/page404/page404.component').then(m => m.Page404Component),
    data: {
      title: 'Page 404'
    }
  },
  {
    path: '500',
    loadComponent: () => import('./views/pages/page500/page500.component').then(m => m.Page500Component),
    data: {
      title: 'Page 500'
    }
  },
  { path: '**', redirectTo: '' }
];
